document.documentElement.classList.add('btj-js');

document.addEventListener('DOMContentLoaded', function () {

  const revealSelectors = [
    '.btj-editorial-text__inner',
    '.btj-featured-product__content-inner',
    '.btj-footer__main'
  ];

  const imageSelectors = [
    '.btj-campaign__media',
    '.btj-collection-grid__media',
    '.btj-featured-product__media'
  ];

  const staggerSelectors = [
    '.btj-product-rail__products'
  ];


  revealSelectors.forEach(function (selector) {

    document
      .querySelectorAll(selector)
      .forEach(function (element) {

        element.classList.add('btj-reveal');

      });

  });


  imageSelectors.forEach(function (selector) {

    document
      .querySelectorAll(selector)
      .forEach(function (element) {

        element.classList.add('btj-image-reveal');

      });

  });


  staggerSelectors.forEach(function (selector) {

    document
      .querySelectorAll(selector)
      .forEach(function (element) {

        element.classList.add('btj-stagger');

      });

  });


  document
    .querySelectorAll('.product-grid')
    .forEach(function (element) {

      element.classList.add('btj-observe-grid');

    });


  const elements = document.querySelectorAll(
    '.btj-reveal, ' +
    '.btj-image-reveal, ' +
    '.btj-stagger, ' +
    '.btj-observe-grid'
  );


  if (!('IntersectionObserver' in window)) {

    elements.forEach(function (element) {

      element.classList.add('btj-visible');

    });

    return;

  }


  const observer = new IntersectionObserver(
    function (entries, observerInstance) {

      entries.forEach(function (entry) {

        if (entry.isIntersecting) {

          entry.target.classList.add(
            'btj-visible'
          );

          observerInstance.unobserve(
            entry.target
          );

        }

      });

    },
    {
      threshold: 0.12,
      rootMargin: '0px 0px -40px 0px'
    }
  );


  elements.forEach(function (element) {

    observer.observe(element);

  });

});
